import { useToast } from '@myhrbox/myhrbox-frontend-core';
import { useIsExaminationActiveQuery } from '@generated/graphql';
import ROUTES from 'constants/routes';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

const useIsExaminationActive = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { showErrorToast } = useToast();
  const { examinationId } = useParams<{ examinationId: string }>();
  const { data, loading } = useIsExaminationActiveQuery({
    variables: { examinationId: examinationId! },
  });
  const isExaminationActive = data?.isExaminationActive;

  useEffect(() => {
    if (!examinationId) {
      navigate(ROUTES.ASSESSMENT, { replace: true });
      showErrorToast(t('assessment.instruction.error.assessmentUnavailable'));
    }
  }, []);

  return { isExaminationActive, loading, examinationId };
};

export default useIsExaminationActive;
